import { countryGroups, GBPCountries, } from '@modules/internationalisation/countryGroup';
import { NoFulfilmentOptions } from '@modules/product/fulfilmentOptions';
import { NoProductOptions } from '@modules/product/productOptions';
import { CountryGroup } from 'helpers/internationalisation/classes/countryGroup';
import { extendedGlyph, glyph } from 'helpers/internationalisation/currency';
import { fixDecimals } from 'helpers/productPrice/subscriptions';
const isNumeric = (num) => num !== null && num !== undefined && !Number.isNaN(num);
function getFirstValidPrice(...prices) {
    return prices.find(isNumeric) ?? 0;
}
function getCountryGroup(country) {
    return countryGroups[CountryGroup.fromCountry(country) ?? GBPCountries];
}
function getProductPrice(productPrices, country, billingPeriod, fulfilmentOption = NoFulfilmentOptions, productOption = NoProductOptions) {
    const countryGroup = getCountryGroup(country);
    const productPrice = productPrices[countryGroup.name]?.[fulfilmentOption]?.[productOption]?.[billingPeriod]?.[countryGroup.currency];
    if (productPrice) {
        return productPrice;
    }
    throw new Error('getProductPrice: product price unavailable');
}
const showPrice = (p, isExtended = true) => {
    const showGlyph = isExtended ? extendedGlyph : glyph;
    return `${showGlyph(p.currency)}${fixDecimals(p.price)}`;
};
function getCurrency(country) {
    const { currency } = getCountryGroup(country);
    return currency;
}
function hackRemoveMeDiscount(discountPercentage) {
    // We have had a misunderstanding around how to get the correct
    // rounding for discount percentages. This is a temporary fix
    if (discountPercentage === 49) {
        return 50;
    }
    else if (discountPercentage === 34) {
        return 35;
    }
    return discountPercentage;
}
/**
 * @param discountedPrice - price after promo discount applied to online price
 * @param onlineVsRetailPerc - % discount of normal online price vs retail price
 * @param discountedVsOnlinePerc - % discount of discountedPrice against normal online price
 */
const getDiscountVsRetail = (discountedPrice, onlineVsRetailPerc, discountedVsOnlinePerc) => {
    const onlinePrice = discountedPrice / (1 - discountedVsOnlinePerc / 100);
    const retailPrice = onlinePrice / (1 - onlineVsRetailPerc / 100);
    const totalSavingVsRetail = (1 - discountedPrice / retailPrice) * 100;
    /**
     * We should never overstate a discount,
     * even by a fraction of a %. Therefore
     * we always round down to the nearest whole number.
     */
    return hackRemoveMeDiscount(Math.floor(totalSavingVsRetail));
};
const allProductPrices = window.guardian.allProductPrices;
export { getProductPrice, getFirstValidPrice, getCurrency, getCountryGroup, showPrice, isNumeric, getDiscountVsRetail, allProductPrices, };
